import React, { createContext, useContext } from 'react';

import { USER_MANAGEMENT_PAGE_SIZE } from './constants';
import { UserManagementFiltersType, UserManagementUserType } from './types';

type UserManagementContextType = {
  items: UserManagementUserType[];
  loading: boolean;
  totalItemsCount: number;
  filters: Partial<UserManagementFiltersType>;
  isMultipleSelection: boolean;
  selectedUserIds: number[];
  selectedUsers: UserManagementUserType[];
  setItems: (payload: any) => void;
  setPage: (page: number) => void;
  setFilters: (filters: any) => void;
  setMultipleSelection: (enabled: boolean) => void;
  setSelectedUserIds: (userIds: number[]) => void;
  setSelectedUsers: (users: UserManagementUserType[]) => void;
  clearSelection: () => void;
  refetch: () => void;
};

export const UserManagementContext = createContext<UserManagementContextType>({
  items: [],
  loading: false,
  totalItemsCount: 0,
  filters: {
    page: 1,
    pageSize: USER_MANAGEMENT_PAGE_SIZE,
    search: '',
    companies: undefined,
    holdings: undefined,
    feature_flags: undefined,
    positions: undefined,
    is_active: undefined,
    last_login: undefined,
    last_invitation: undefined,
  },
  isMultipleSelection: false,
  selectedUserIds: [],
  selectedUsers: [],
  setItems: () => {
    // Do nothing
  },
  setPage: () => {
    // Do nothing
  },
  setFilters: () => {
    // Do nothing
  },
  setMultipleSelection: () => {
    // Do nothing
  },
  setSelectedUserIds: () => {
    // Do nothing
  },
  setSelectedUsers: () => {
    // Do nothing
  },
  clearSelection: () => {
    // Do nothing
  },
  refetch: () => {
    // Do nothing
  },
});

export const useUserManagementContext = () => useContext(UserManagementContext);
